import { render, staticRenderFns } from "./ReadThePaper.vue?vue&type=template&id=19750f2a&"
import script from "./ReadThePaper.vue?vue&type=script&lang=js&"
export * from "./ReadThePaper.vue?vue&type=script&lang=js&"
import style0 from "./ReadThePaper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports